export class Month {
  protected months = [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec',
  ];

  public getKey(monthNumber: number): string {
    return this.months[monthNumber];
  }
}
